import { getFilterOrder } from './computeFilters';
import React from 'react';
import imageMap from './imageMap';

const componentFilters = {
  0:{type:'discrete',tableValues:"0 0 0 0 0 0 0 0"},
  1:{type:'identity'}
}

const colorMap = {
  none:[1,1,1],
  red:[1,0,0],
  green:[0,1,0],
  blue:[0,0,1],
  magenta:[1,0,1],
  yellow:[1,1,0],
  cyan:[0,1,1],
  //grey:[0.2989,0.5870,0.114],
  grey:[1,1,1],


}

export function computeFilterArgs(adjustmentsList){
  let filterArgsList = adjustmentsList.map((adj,imIdx) => {
    let image = imageMap[adj.imgurl ] || adj.imgurl;
    let filterOrder = getFilterOrder(adj);
    let filterArgs = [
      { filterKey: 'feImage', xlinkHref: image, result: `in-${imIdx}` }
    ];
    
    filterOrder.forEach(filterKey => {
      let filterValue = adj[filterKey]
      if (filterValue != null){
        let thisFilterArgs = getFilterArgs({filterKey,filterValue})
        if (thisFilterArgs != null) {
          filterArgs.push(thisFilterArgs);
        }
      }
    })

    filterArgs.forEach((args,ii) => {
      args.inKey = ii === 0 ? `in-${imIdx}` : `intermediate-${imIdx}-${ii-1}`;
      args.result = ii === filterArgs.length - 1 ? `result-${imIdx}` : `intermediate-${imIdx}-${ii}`;
    })

    return filterArgs;
  });
  return filterArgsList;
}


function getFilterArgs({filterKey,filterValue}){

  if( filterKey === "contrast" ){
    let intercept = -0.5 * filterValue + 0.5;
    return { type:"linear", slope:filterValue, intercept, filterKey };
  }else if( filterKey === "brightness" ){
    return { type:"linear", slope:filterValue, intercept:0, filterKey }
  }else if( filterKey === "inverted" ){
    return filterValue ? { type:"linear", slope:-1, intercept:1, filterKey } : null;
  }else if( filterKey === "colorProjection" ){
    //debugger;
    return { type:"colorProjection", filterKey, filterValue }
  }else if( filterKey === "gamma" ){
    return { type:"gamma", filterKey, filterValue, amplitude:1, exponent:filterValue, offset:0 }
  }

}

function colorComponentTransfer({inKey,result,filterValue}){

  //debugger;
  let colorProjection = filterValue;
  let color = colorProjection;
  let elements = colorMap[color];

  if( !color || !filterValue || filterValue === "none" ){

    elements = [1,1,1]
    //debugger;

   return (
    <feComponentTransfer {...{in:inKey,result}}>
      <feFuncR {...componentFilters[ elements[0] ] }/>
      <feFuncG {...componentFilters[ elements[1] ] }/>
      <feFuncB {...componentFilters[ elements[2] ] }/>
    </feComponentTransfer>
  )
  }


  return (
    <feComponentTransfer {...{in:inKey,result}}>
      <feFuncR {...componentFilters[ elements[0] ] }/>
      <feFuncG {...componentFilters[ elements[1] ] }/>
      <feFuncB {...componentFilters[ elements[2] ] }/>
    </feComponentTransfer>
  )
}

function gamma({inKey,result,filterValue}){

  let gamma = filterValue;
  let elements;// = colorMap[color];

  if( !filterValue || filterValue === "none" ){

    //debugger;
    return null;
  }


  return (
    <feComponentTransfer {...{in:inKey,result}}>
      <feFuncR {...componentFilters[ elements[0] ] }/>
      <feFuncG {...componentFilters[ elements[1] ] }/>
      <feFuncB {...componentFilters[ elements[2] ] }/>
    </feComponentTransfer>
  )
}


function FeComponentTransfer({ inKey, result, slope, intercept, ...args }){
  let innerFunctions = ["R","G","B"].map( letter => {
    let comp = "feFunc"+letter;
    return React.createElement(comp,{
      type:"linear",
      slope,
      intercept,
      ...args,
    })
  })

  return (
    <feComponentTransfer {...{in:inKey, result} }>
      {innerFunctions}
    </feComponentTransfer>
  )
}

function generateCompositeTriplets(list) {
    const result = [];
    for (let i = 1; i < list.length; i++) {
      const prev = i === 1 ? list[0] : `sum-${i-1}`;
      const curr = list[i];
      const sumId = i === list.length-1 ? `source` : `sum-${i}`;
      result.push(
        <feComposite in={prev} in2={curr} operator="arithmetic" k1="0" k2={1} k3={1} k4="0" result={sumId}/>
      );
    }
    return result;
}

export default function SvgImageFilter({ filterArgsList, filterName }){
  if( filterArgsList.length === 0 ){
    return null;
  }

  return (

    <filter colorInterpolationFilters={"sRGB"} height="100%" width="100%" x="0%" y="0%"
      //filterUnits="objectBoundingBox" height="100%" width="100%" x="0%" y="0%"
      filterUnits="userSpaceOnUse"
      primitiveUnits="userSpaceOnUse"
      id={filterName}>
      {filterArgsList.map(filterArgs => filterArgs.map(args => {
        if( args.filterKey === "colorProjection" ){
          return colorComponentTransfer(args);
        } else if (args.filterKey === 'feImage') {
          return <feImage {...args} />
        }else{
          return <FeComponentTransfer {...{...args}}/>
        }
      }))}
      {generateCompositeTriplets(filterArgsList.map((_, i) => `result-${i}`))}
    </filter>
  )
}
